var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WalletAccordion',{attrs:{"title":'Advance Information',"id":'headingTwo',"target":'advance'}},[_c('section',[_c('p',[_vm._v("KYC")]),_c('span',[_vm._v(_vm._s(_vm.wallet.kyc || "None")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }